"use client";
import Link from "next/link";
import Image from "next/image";
import { FadeUp, StaggerContainer, StaggerItem } from "@/components/ui/section";
import Button from "@/components/ui/button";
import { useTranslations } from "next-intl";

export default function Projects({ heading, projects }) {
  const t = useTranslations("home");
  const featured = projects?.slice(0, 6) ?? [];

  return (
    <section className="py-24 lg:py-32 bg-zinc-900/30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <FadeUp className="flex flex-col sm:flex-row items-start sm:items-end justify-between gap-6 mb-12">
          <h2 className="text-3xl lg:text-5xl font-bold text-white max-w-lg">
            {heading}
          </h2>
          <Link href="/portfolio">
            <Button variant="secondary" size="md">
              {t("viewAllProjects")}
            </Button>
          </Link>
        </FadeUp>

        <StaggerContainer className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {featured.map((project) => (
            <StaggerItem key={project.slug}>
              <Link href={`/portfolio/${project.slug}`}>
                <div className="group relative overflow-hidden rounded-2xl bg-zinc-900 border border-white/[0.08] hover:border-violet-500/30 transition-all duration-300 aspect-[4/3]">
                  {project.image && (
                    <Image
                      src={project.image}
                      alt={project.title}
                      fill
                      className="object-cover transition-transform duration-500 group-hover:scale-105"
                    />
                  )}
                  {/* Always-visible gradient + title */}
                  <div className="absolute inset-0 bg-gradient-to-t from-zinc-950/85 via-zinc-950/20 to-transparent" />

                  <div className="absolute inset-x-0 bottom-0 p-5">
                    {project.tags?.[0] && (
                      <span className="text-[10px] font-semibold text-violet-400 uppercase tracking-widest mb-1.5 block">
                        {project.tags[0]}
                      </span>
                    )}
                    <h3 className="text-sm font-semibold text-white leading-snug group-hover:text-violet-300 transition-colors">
                      {project.title}
                    </h3>
                  </div>
                </div>
              </Link>
            </StaggerItem>
          ))}
        </StaggerContainer>
      </div>
    </section>
  );
}
